import {
  YEARS_CREATE_FAIL,
  YEARS_CREATE_REQUEST,
  YEARS_CREATE_SUCCESS,
  YEARS_UPDATE_FAIL,
  YEARS_UPDATE_REQUEST,
  YEARS_UPDATE_SUCCESS,
  YEARS_PATCH_FAIL,
  YEARS_PATCH_REQUEST,
  YEARS_PATCH_SUCCESS,
  YEARS_LIST_FAIL,
  YEARS_LIST_REQUEST,
  YEARS_LIST_SUCCESS,
  VALUES_UPDATE_FAIL,
  YEARS_SINGLE_FAIL,
  YEARS_SINGLE_SUCCESS,
  YEARS_SINGLE_REQUEST,
  VALUES_UPDATE_REQUEST,
  VALUES_UPDATE_SUCCESS,
} from "../constants/yearsConstants";

export const yearCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case YEARS_CREATE_REQUEST:
      return { loading: true };
    case YEARS_CREATE_SUCCESS:
      return { loading: false, success: true };
    case YEARS_CREATE_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

export const yearSingleReducer = (
  state = { year: null, version: 0, fieldMeta: {} },
  action,
) => {
  switch (action.type) {
    case YEARS_SINGLE_REQUEST:
      return { loading: true, version: 0, fieldMeta: {} };
    case YEARS_SINGLE_SUCCESS: {
      // Strip optimistic-concurrency metadata from the payload so the
      // local form state doesn't pick up _version/_fieldMeta keys when it
      // spreads `yearSingle` into its working copy.
      const payload = action.payload || {};
      const { _version, _fieldMeta, ...flat } = payload;
      return {
        loading: false,
        year: flat,
        version: typeof _version === "number" ? _version : 0,
        fieldMeta: _fieldMeta || {},
      };
    }
    case YEARS_SINGLE_FAIL:
      return { loading: false, error: action.payload };
    case YEARS_PATCH_REQUEST:
      return { ...state, patchInflight: true };
    case YEARS_PATCH_SUCCESS: {
      const payload = action.payload || {};
      return {
        ...state,
        patchInflight: false,
        version:
          typeof payload.version === "number" ? payload.version : state.version,
        fieldMeta: payload.fieldMeta || state.fieldMeta,
        patchError: undefined,
      };
    }
    case YEARS_PATCH_FAIL:
      return { ...state, patchInflight: false, patchError: action.payload };
    default:
      return state;
  }
};

export const yearUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case YEARS_UPDATE_REQUEST:
      return { loading: true };
    case YEARS_UPDATE_SUCCESS:
      return { loading: false, success: true };
    case YEARS_UPDATE_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

export const valuesUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case VALUES_UPDATE_REQUEST:
      return { loading: true };
    case VALUES_UPDATE_SUCCESS:
      return { loading: false, success: true };
    case VALUES_UPDATE_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

export const yearListReducer = (state = { years: [] }, action) => {
  switch (action.type) {
    case YEARS_LIST_REQUEST:
      return { loading: true };
    case YEARS_LIST_SUCCESS:
      return { loading: false, years: action.payload };
    case YEARS_LIST_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};
